import { CLOSE_MODAL, CLOSE_PANEL, OPEN_PANEL, RESET_PANEL } from 'reducers/actions-types';
import scrollActions from 'reducers/modules/scroll/actions';


function open({ facet, content }, dispatch, getState) {
    if (getState().modal.isVisible) {
        dispatch({ type: CLOSE_MODAL });
    }
    dispatch(scrollActions.lock());
    dispatch({ type: OPEN_PANEL, facet, content });
}

function close(dispatch, getState) {
    if (!getState().panel.isOpen) {
        return;
    }

    if (!getState().modal.isVisible) {
        dispatch(scrollActions.unlock());
    }

    dispatch({ type: CLOSE_PANEL });
}

export default {
    open({ facet, content }) {
        return open.bind(null, { facet, content });
    },

    reset() {
        return { type: RESET_PANEL };
    },

    close() {
        return close;
    },

    toggle({ facet, content }) {
        return function(dispatch, getState) {
            const { isOpen } = getState().panel;

            if (isOpen) {
                close(dispatch, getState);
            } else {
                open({ facet, content }, dispatch, getState);
            }
        };
    },
};




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/panel/actions.js